import React, { useState, useEffect,useMemo } from "react";
import Layout from "../../Components/Layout";
import InfoCard from "../../Components/Model/InfoCard";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import axios from "axios";
import { getUserRole } from "../offboarding/Offboarding";

ChartJS.register(ArcElement, Tooltip, Legend);

const myTasks = [
  {
    task: "Fix login authentication bug",
    project: "B2B Project",
    priority: "High",
  },
  { task: "Implement payment gateway", project: "Untagged", priority: "High" },
  { task: "Update documentation", project: "i-Hr", priority: "High" },
  {
    task: "Fix login authentication bug",
    project: "ALC Web",
    priority: "Medium",
  },
  {
    task: "Implement payment gateway",
    project: "Untagged",
    priority: "Medium",
  },
  { task: "Update documentation", project: "i-Hr", priority: "Medium" },
  {
    task: "Fix login authentication bug",
    project: "B2B Project",
    priority: "Low",
  },
  { task: "Implement payment gateway", project: "Untagged", priority: "Low" },
  { task: "Update documentation", project: "i-Hr", priority: "Low" },
];

const overdueTasks = [
  {
    task: "Login API Integration Fix",
    due: "28 Nov '25",
    project: "B2B Project",
  },
  { task: "Implement payment gateway", due: "01 Dec '25", project: "i-Hr" },
  { task: "Update documentation", due: "28 Nov '25", project: "ALC Web" },
  { task: "Fix login authentication bug", due: "01 Dec '25", project: "i-Hr" },
];
const projects = [
  {
    name: "i-HR",
    owner: "Atul Thakur",
    start: "28 Nov '25",
    status: "InProgress",
  },
  {
    name: "ALC website",
    owner: "Atul Thakur",
    start: "28 Nov '25",
    status: "InProgress",
  },
  {
    name: "WeLearn App",
    owner: "Atul Thakur",
    start: "28 Nov '25",
    status: "InProgress",
  },
  {
    name: "Digitalmines",
    owner: "Atul Thakur",
    start: "28 Nov '25",
    status: "InProgress",
  },
];
const projectColors = {
  "B2B Project": { bg: "#E3F2FD", color: "#0d6efd" },
  Untagged: { bg: "#F3E5F5", color: "#6f42c1" },
  "i-Hr": { bg: "#E8F5E9", color: "#28a745" },
  "ALC Web": { bg: "#FFF3CD", color: "#ffc107" },
};

const chartOptions = {
  cutout: "70%", // thinner ring
  borderRadius: 20,
  plugins: {
    // legend: {
    //   position: 'left',
    //    align: 'start',
    //   labels: {
    //     boxWidth: 14,
    //     padding: 12,
    //     font: {
    //       size: 14,
    //       weight: '500',
    //     },
    //     color: '#333',
    //   },
    // },
    legend: {
      display: false,
    },

    tooltip: {
      callbacks: {
        label: (context) => `${context.label}: ${context.raw} tasks`,
      },
    },
  },
};


function ProjectTrack() {
  const navigate = useNavigate();
  // ✅ States for each API response
  const [taskList, setTaskList] = useState([]);
  const [taskCount, setTaskCount] = useState(0);
  const [projectList, setProjectList] = useState([]);
  const [projectContribution, setProjectContribution] = useState([]);
  const [overdueTaskList, setOverdueTaskList] = useState([]);
   const [userRole, setUserRole] = useState(null);


  const token = localStorage.getItem("token");
   useEffect(() => {
    
    if (token) {
      const { roles } = getUserRole(token);
      setUserRole(roles);
    }
  }, []);
console.log(userRole,"role")
  useEffect(() => {
    // ✅ Define async function to call APIs
    const fetchData = async () => {
      try {
        const headers = {
          Authorization: `Bearer ${token}`, // ✅ Pass token here
        };

        const [
          taskListRes,
          taskCountRes,
          projectListRes,
          projectContributionRes,
          overdueTaskListRes,
        ] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/project-dashboard/task-list?page=0&size=10`,
            { headers }
          ),
          axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/project-dashboard/task-count`,
            { headers }
          ),
          axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/project-dashboard/project-list?page=0&size=10`,
            { headers }
          ),
          axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/project-dashboard/project-contribution`,
            { headers }
          ),
          axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/project-dashboard/overdue-task-list?page=0&size=10`,
            { headers }
          ),
        ]);

        // ✅ Update states
        setTaskList(taskListRes?.data?.content);
        setTaskCount(taskCountRes.data);
        setProjectList(projectListRes.data?.content);
        setProjectContribution(projectContributionRes.data);
        setOverdueTaskList(overdueTaskListRes.data?.content);
      } catch (error) {
        console.error("Error fetching project dashboard data:", error);
      }
    };

    fetchData();
  }, []);
  const cardData = taskCount
    ? [
        {
          id: 1,
          title: "Open Task",
          count: taskCount.taskInProgressCount,
          bg: "#FFFEE6",
          icon: "mingcute:time-line",
          color: "#D4D300",
        },
        {
          id: 2,
          title: "Closed Task",
          count: taskCount.taskCompletedCount,
          bg: "#E6FFF3",
          icon: "lets-icons:done-ring-round",
          color: "#00A86B",
        },
        {
          id: 3,
          title: "Total Task",
          count: taskCount.totalTaskCount,
          bg: "#E6F0FF",
          icon: "icon-park-outline:list",
          color: "#0057D9",
        },

        {
          id: 4,
          title: "Untagged Task",
          count: taskCount.unTaggedTaskCount,
          bg: "#FFE6E6",
          icon: "mdi:tag-outline",
          color: "#D90000",
        },
      ]
    : [];
// 🎨 Define some colors (you can expand or randomize)
const colors = ["#00AFEF", "#01E655", "#E6C001", "#D90000", "#0057D9", "#00A86B"];


    const chartData = {
  labels: projectContribution.map((proj) => proj.projectName),

  datasets: [
   {
        data: projectContribution.map((proj) => proj.completedTaskCount),
        backgroundColor: projectContribution.map(
          (_, idx) => colors[idx % colors.length] // cycle through colors
        ),
        borderWidth: 1,
      },

  ],
};

      const getRandomColorPair = () => {
    const colors = [
      { bg: "#E3F2FD", color: "#0d6efd" },
      { bg: "#F3E5F5", color: "#6f42c1" },
      { bg: "#E8F5E9", color: "#28a745" },
      { bg: "#FFF3CD", color: "#ffc107" },
      { bg: "#FFE6E6", color: "#D90000" },
      { bg: "#E6F0FF", color: "#0057D9" },
      { bg: "#E6FFF3", color: "#00A86B" },
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  // 🗂️ Assign random colors to each unique projectName once
  const projectColors = useMemo(() => {
    const map = {};
    overdueTaskList?.forEach((task) => {
      if (!map[task.projectName]) {
        map[task.projectName] = getRandomColorPair();
      }
    });
    return map;
  }, [overdueTaskList]);


  return (
    <Layout>
      <div className="backgound-main-content">
        {/* <div className="leave-management-container "> */}
        <div className="p-3 d-flex justify-content-between">
          <p style={{ fontSize: "22px", fontWeight: 600 }}>Overview </p>
          <button
            className="add-emp-button"
            style={{ fontWeight: "500", fontSize: "0.85rem" }}
            onClick={() => navigate("/create-new-project")}
          >
            <Icon icon="material-symbols:add-rounded" width="18" height="18" />{" "}
            New Project
          </button>
        </div>
        <div className="row g-3 ">
          {cardData.map((item) => (
            <div className="col-12 col-sm-6 col-md-6 col-lg-3" key={item.id}>
              <InfoCard
                title={item.title}
                count={item.count}
                bg={item.bg}
                icon={item.icon}
                color={item.color}
              />
            </div>
          ))}
        </div>
        {/* </div> */}
        <div className="container mt-4">
          <div className="row g-4">
            {/* My Tasks Section */}
            <div className="col-md-6">
              <div className="border rounded-3 p-3 shadow-sm bg-white" style={{ minHeight: "480px", overflow: "auto" }}>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h5 className="mb-0 fw-semibold">
                    My Tasks ({taskList.length})
                  </h5>
                  <div>
                      <button
                    className="btn btn-sm fw-bold px-3"
                    style={{
                      fontWeight: "500",
                      fontSize: "0.85rem",
                      color: "#909090",
                    }}
                    onClick={() => navigate("/mytask")}
                  >
                    <span className="ms-1">View All</span>
                  </button>
                 
                  <button
                    className="btn btn-sm text-primary fw-bold px-3 "
                    style={{ fontWeight: "500", fontSize: "0.85rem" }}
                    onClick={() => navigate("/createtask")}
                  >
                    + New Task
                  </button>
                </div>
                 </div>
                <div
                  style={{
                    height: "1px",
                    backgroundColor: "#e0e0e0",
                    marginBottom: "10px",
                  }}
                ></div>

             <div className="rounded-2">
  {taskList.map((task, index) => {
    // 🎨 Priority color styles (bg + text color)
    const priorityColors = {
      Pending: { bg: "#BADAFF", color: "#0d6efd" },
      Inprogress: { bg: "#FEF4B5", color: "#C5A500" },
      COMPLETED: { bg: "#e8f5e9", color: "#28a745" },
    };

    const priorityStyle = priorityColors[task.status] || {
      bg: "#f8f9fa",
      color: "#6c757d",
    };

    return (
      <div
        key={index}
        className="d-flex justify-content-between align-items-center border-bottom py-2 px-1"
        style={{ fontSize: "0.95rem" }}
      >
        {/* ✅ Task Title */}
        <div className="fw-medium" style={{ flex: 1 }}>
          {task.taskTitle || "Untitled Task"}
        </div>

        <div className="d-flex align-items-center" style={{ gap: "8px" }}>
          {/* ✅ Project pill */}
          <div
            className="small px-2 py-1 rounded"
            style={{
              backgroundColor:
                projectColors[task.projectName]?.bg || "#f8f9fa",
              color: projectColors[task.projectName]?.color || "#6c757d",
              fontWeight: "500",
              minWidth: "90px",
              textAlign: "center",
            }}
          >
            {task.projectName}
          </div>

          {/* ✅ Priority pill */}
          <span
            className="badge rounded-pill"
            style={{
              backgroundColor: priorityStyle.bg,
              color: priorityStyle.color, // ✅ only one color now
              fontSize: "0.75rem",
              padding: "6px 10px",
              minWidth: "70px",
              textAlign: "center",
            }}
          >
            {task.priority || task.status}
          </span>
        </div>
      </div>
    );
  })}
</div>
              </div>
            </div>

            {/* Overdue Tasks Section */}
            <div className="col-md-6">
              <div
                className="border rounded-3 p-3 shadow-sm bg-white"
                style={{ minHeight: "480px", overflow: "auto" }}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0 fw-semibold">Overdue Tasks ({overdueTaskList.length})</h5>
                  {/* <button
                    className="btn btn-sm text-danger fw-bold"
                    style={{ fontWeight: "500", fontSize: "0.85rem" }}
                    onClick={() => navigate("/new-task")}
                  >
                    + Add
                  </button> */}
                </div>
                <div
                  style={{
                    height: "2px",
                    backgroundColor: "#e0e0e0",
                    marginBottom: "10px",
                  }}
                ></div>

                <div className="rounded-2">
                  {overdueTaskList?.map((task, index) => {
                    // const projectColors = {
                    //   "B2B Project": { bg: "#E3F2FD", color: "#0d6efd" },
                    //   Untagged: { bg: "#F3E5F5", color: "#6f42c1" },
                    //   "i-Hr": { bg: "#E8F5E9", color: "#28a745" },
                    //   "ALC Web": { bg: "#FFF3CD", color: "#ffc107" },
                    // };

                    const projectStyle = projectColors[task.projectName] || {
                      bg: "#f8f9fa",
                      color: "#6c757d",
                    };

                    return (
                      <div
                        key={task.taskId || index}
                        className="d-flex justify-content-between align-items-center border-bottom py-2 px-1"
                        style={{ fontSize: "0.95rem" }}
                      >
                        {/* ✅ Task Title */}
                        <div className="fw-medium">
                          {task.taskTitle || "Untitled Task"}
                        </div>

                        <div className="d-flex gap-2">
                          {/* ✅ End Date */}
                          <div
                            className="text-danger small"
                            style={{
                              textAlign: "center",
                              fontWeight: "500",
                              minWidth: "90px",
                            }}
                          >
                            {task.endDate}
                          </div>

                          {/* ✅ Project Name */}
                          <div
                            className="small px-2 py-1 rounded"
                            style={{
                              backgroundColor: projectStyle.bg,
                              color: projectStyle.color,
                              fontWeight: "500",
                              minWidth: "90px",
                              textAlign: "center",
                            }}
                          >
                            {task.projectName}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-4">
      

          <div className="row g-4">
            {/* My Projects Table */}
            <div className="col-md-6">
              <div
                className="border rounded-3 p-2 shadow-sm bg-white"
                style={{ maxHeight: "400px", overflow: "auto" }}
              >
                <div className=" d-flex justify-content-between">
                  <h5 className="fw-semibold mb-3">
                    My Projects ({projectList.length})
                  </h5>
                  <button
                    className="btn btn-sm text-primary fw-bold px-3"
                    style={{
                      fontWeight: "500",
                      fontSize: "0.85rem",
                      color: "#00AFEF",
                    }}
                    onClick={() => navigate("/projecttrack")}
                  >
                    <span className="ms-1">View All</span>
                  </button>
                </div>
                <div
                  style={{
                    height: "1px",
                    backgroundColor: "#e5e5e5",
                    marginBottom: "12px",
                  }}
                ></div>
                <div className="rounded-2">
                  {/* Header Row */}
                  <div
                    className="d-flex justify-content-between align-items-center border-bottom py-2 px-1 fw-semibold"
                    style={{
                      fontSize: "0.9rem",
                      backgroundColor: "#f8f9fa",
                      color: "#6c757d",
                    }}
                  >
                    <div style={{ flex: 1 }}>Project Name</div>
                    <div style={{ minWidth: "120px", textAlign: "center" }}>
                      Owner
                    </div>
                    <div style={{ minWidth: "120px", textAlign: "center" }}>
                      Start Date
                    </div>
                    <div style={{ minWidth: "120px", textAlign: "center" }}>
                      Status
                    </div>
                  </div>

                  {/* Data Rows */}
                  {projectList?.map((proj, index) => {
                    // Status styles
                    let statusStyle = {
                      backgroundColor: "#FFFBE4",
                      color: "#C5C222",
                    };

                    return (
                      <div
                        key={index}
                        className="d-flex justify-content-between align-items-center border-bottom py-2 px-1"
                        style={{ fontSize: "0.95rem" }}
                      >
                        {/* Project Name */}
                        <div className="fw-medium" style={{ flex: 1 }}>
                          {proj.projectName}
                        </div>

                        {/* Owner */}
                        <div
                          className="small px-2 py-1 rounded"
                          style={{
                            color: "#6c757d",
                            fontWeight: "500",
                            minWidth: "120px",
                            textAlign: "center",
                          }}
                        >
                          {proj.ownerName}
                        </div>

                        {/* Start Date */}
                        <div
                          className="small px-2 py-1 rounded"
                          style={{
                            color: "#555",
                            fontWeight: "500",
                            minWidth: "120px",
                            textAlign: "center",
                          }}
                        >
                          {proj.startDate}
                        </div>

                        {/* Status */}
                        <span
                          className="px-3 py-1 badge rounded-pill"
                          style={{
                            ...statusStyle,
                            fontSize: "0.75rem",
                            fontWeight: "600",
                            minWidth: "120px",
                            textAlign: "center",
                            display: "inline-block",
                          }}
                        >
                          {proj.status}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
 {userRole?.includes("ROLE_EMP") && (
<>

            {/* Doughnut Chart */}
            <div className="col-md-6">
              <div
                className="border rounded-3 p-2 shadow-sm bg-white "
                style={{ minHeight: "280px", maxHeight: "400px" }}
              >
                <h5 className="fw-semibold mb-4 text-start">
                  My Project Contribution -{" "}
                  <span className="text-secondary">Task Done</span>
                </h5>
                <div
                  style={{
                    height: "2px",
                    backgroundColor: "#e0e0e0",
                    marginBottom: "10px",
                  }}
                ></div>

                <div className="d-flex align-items-center justify-content-between">
                  {/* Custom Legend */}
                    <div className="d-flex flex-column gap-3">
            {projectContribution.map((proj, idx) => (
              <div
                key={proj.projectId}
                className="fw-semibold"
                style={{ color: colors[idx % colors.length] }}
              >
                {proj.projectName}
              </div>
            ))}
          </div>

                  {/* Doughnut Chart */}
                  <div style={{ width: "180px" }}>
                    <Doughnut data={chartData} options={chartOptions} />
                  </div>
                </div>
              </div>
            </div>
            </>
            )}

          </div>
          
        </div>
      </div>
    </Layout>
  );
}

export default ProjectTrack;
